import TabNav from "@/components/common/tabs/TabNav";
import TabNavLink from "@/components/common/tabs/TabNavLink";
import { faBell, faInfo, faPencil } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PageHeader from "components/common/page/PageHeader";
import Profile from "components/entities/app/profile/Profile";
import { AppRoutes } from "config/router";
import { useTranslation } from "react-i18next";
import { Link, Outlet } from "react-router-dom";

const ProfilePage = () => {
    const [t] = useTranslation();
    return (
        <div className="lg:px-5">
            <TabNav>
                <TabNavLink to={AppRoutes.PROFILE} text="pages.info" icon={faInfo} match={/^\/profile(\/)?$/} />
                <TabNavLink to={AppRoutes.PROFILE_NOTIFICATIONS} text="common.notifications" icon={faBell} match={/^\/profile(\/)?$/} />
            </TabNav>
            <div>
                <Outlet />
            </div>
        </div>
    );
}

export default ProfilePage;
